<template>
  <div class="page invitationList">
    <!-- <app-bar class="f-s-16" color="#333" background="#FFF" :isBack="false">
      <div slot="title">赚钱了</div>
    </app-bar> -->
    <img src="../assets/img/zql/register/banner_top.png" alt srcset />
    <div class="login-block">
      <div class="inviter-msg">
        <div class="inviter-msg-head">
          <img :src="invitor.ico ? invitor.ico : require('../assets/img/icon_defaulthead.png')" alt />
        </div>
        <div class="inviter-msg-text">
          <div class="inviter-msg-text-name">{{invitor.alias}}</div>
          <div class="inviter-msg-text-span">邀请你来注册</div>
        </div>
      </div>
      <div class="form">
        <div class="form-item">
          <div class="form-input">
            <input v-model="mobile" type="tel" placeholder="请输入你的手机号" maxlength="11" />
          </div>
        </div>
        <div class="form-item">
          <div class="form-input">
            <input v-model="verifyCode" type="text" placeholder="图形验证码" maxlength="4" />
          </div>
          <div class="from-input-right">
            <img @click="getCaptchaImage" :src="imageBase64" alt />
          </div>
        </div>
        <div class="form-item">
          <div class="form-input">
            <input v-model="code" type="text" placeholder="验证码" maxlength="6" />
          </div>
          <div class="from-input-right from-button">
            <div @click="sendSms" :disabled="smsTime > 0">{{codeText}}</div>
          </div>
        </div>
      </div>
      <div class="button" @click="register">立即注册</div>
    </div>
  </div>
</template>

<script>
// import this.$axios from "this.$axios";
// eslint-disable-next-line no-undef
export default {
  components: {
    // appBar
  },
  data() {
    return {
      mobile: "",
      verifyCode: "",
      openDialog: false,
      invitor: {},
      imageBase64: "",
      key: "",
      code: "",
      smsTime: 0
    };
  },
  computed: {
    codeText() {
      if (this.smsTime > 0) {
        return `${this.smsTime}s`;
      } else {
        return "获取验证码";
      }
    },
    canRegister() {
      return this.mobile.length === 11 && this.code.length === 6;
    }
  },
  methods: {
    // register() {
    //     this.openDialog = true
    // },
    sendSms() {
      if (!this.smsTime == 0) {
        // 倒计时中
        return
      }
      if (this.mobile.length != 11) {
        this.$bhUi.Toast({ text: "请填写正确的手机号" });
        return;
      }
      if (!this.verifyCode) {
        this.$bhUi.Toast({ text: "请输入图形验证码" });
        return
      }
      
      this.$axios
        .post("/sys/sms/send", {
          mobile: this.mobile,
          verifyCode: this.verifyCode,
          imageKey: this.key,
          purpose: 2
        })
        .then(res => {
          // console.log(res.data.code)
          if (res.code === 200) {
            this.$bhUi.Toast({ text: "验证码已发送至您的手机" });
            // this.$toast.message('验证码已发送至您的手机')
            this.smsTime = 60;
            let timeStart = setInterval(() => {
              if (this.smsTime > 0) {
                this.smsTime--;
              } else {
                clearInterval(timeStart);
              }
            }, 1000);
          } else if (res.data.code == 500) {
            let msg = res.data.msg;
            if (msg && (msg.includes('验证码错误'))) {
              // 清空图片验证码
              this.verifyCode = '';
              // 刷新图片验证码
              this.getCaptchaImage();
              return
            }
            setTimeout(() => {
              this.$router.push({path: `/download?a=${(Math.random() * 1000).toFixed()}`, query: {appId: this.$route.query.appId, id: this.$route.query.id}})
            }, 2000);
          } else {
            this.getCaptchaImage();
          }
        })
    },
    register() {
      // let vm = this
      this.canRegister
        ? this.$axios
            .post("/user/regist", {
              mobile: this.mobile,
              verifyCode: this.code,
              refenceId: this.$route.query.id,
              saleId: this.$route.query.saleId,
              appId: this.$route.query.appId,
              chlCode: this.$route.query.chlCode
            })
            .then(res => {
              if (res.code === 200) {
                this.$bhUi.Toast({ text: "注册成功，即将为您跳转至下载页" });
                setTimeout(() => {
                  this.$router.push({path: `/download2?a=${(Math.random() * 1000).toFixed()}`, query: {appId: this.$route.query.appId, id: this.$route.query.id}})
                }, 2000);
              } else if (res.data.code === 500) {
                let msg = res.data.msg;
                if (msg.includes('验证码错误') || msg.includes('请不要重复提交')) {
                  return;
                } else {
                  setTimeout(() => {
                    this.$router.push({path: `/download?a=${(Math.random() * 1000).toFixed()}`, query: {appId: this.$route.query.appId, id: this.$route.query.id}})
                  }, 2000); 
                }
              } else {
                this.getCaptchaImage();
              }
            })
        : this.$bhUi.Toast({ text: "请完整填写信息" });
    },
    getCaptchaImage() {
      this.$axios.get("/file/getCaptchaImage").then(res => {
        if (res.code === 200) {
          this.imageBase64 = res.data.imageBase64;
          this.key = res.data.key;
        }
      });
    },
    simpleInfo() {
      this.$axios.get("/user/simpleInfo", {
        params: {
          id: this.$route.query.id
        }
      })
      .then(res => {
        if (res.code === 200 && res.data) {
          this.invitor = res.data
        }
      })
    },
    getDownLoadUrl() {
      // console.log(window.downUrl)
    }
  },
  created() {
    this.getCaptchaImage();
    // console.log(this.$route.query.userId)
    this.simpleInfo();
    // this.getDownLoadUrl()
  }
};
</script>

<style lang="less" scoped>
.page {
  background: linear-gradient(
    0deg,
    rgba(255, 99, 27, 1) 0%,
    rgba(254, 107, 29, 1) 68%,
    rgba(255, 97, 52, 1) 84%,
    rgba(254, 163, 14, 1) 100%
  );
  height: 100%;
  > img {
    width: 100%;
    margin-bottom: -60%;
  }
  .login-block {
    margin: 0 15px 20px;
    background-color: #fcfdfd;
    border-radius: 6px;
    padding: 0 36px 30px;
    box-sizing: border-box;
    position: relative;
    .boy {
      width: 102px;
      // height: ;: 102px;
      position: absolute;
      top: 0;
      right: 0;
      transform: translateY(-125px);
    }
    .inviter-msg {
      display: flex;
      padding-top: 24px;
      align-items: center;
      margin-bottom: 19px;
      .inviter-msg-head {
        width: 36px;
        height: 36px;
        margin-right: 12px;
        img {
          width: 36px;
          height: 36px;
        }
      }
      .inviter-msg-text {
        font-family: PingFang SC;
        .inviter-msg-text-name {
          text-align: left;
          font-size: 16px;
          font-weight: 400;
          color: rgba(38, 39, 40, 1);
        }
        .inviter-msg-text-span {
          font-size: 13px;
          font-weight: 300;
          color: rgba(188, 191, 194, 1);
        }
      }
    }
    .form {
      .form-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 18px;
        &:last-child {
          margin-bottom: 16px;
        }
        .form-input {
          flex-grow: 1;
          input {
            width: 100%;
            height: 40px;
            border: 1px solid rgba(213, 215, 219, 1);
            border-radius: 4px;
            outline: none;
            font-size: 17px;
            text-indent: 17px;
            font-family: PingFang SC;
            font-weight: 300;
            // color: rgba(213, 215, 219, 1);
          }
        }
        .from-input-right {
          width: 114px;
          height: 40px;
          margin-left: 12px;
          img {
            width: 100%;
            height: 100%;
          }
          &.from-button {
            background:linear-gradient(90deg,rgba(254,170,0,1) 0%,rgba(255,209,5,1) 100%);
            border-radius:100px;
            // border-radius: 4px;
            color: #fff;
            line-height: 40px;
            text-align: center;
            font-size: 17px;
            font-family: PingFang SC;
            font-weight: 300;
          }
        }
      }
    }
    .file {
      font-size: 13px;
      font-weight: 300;
      color: rgba(188, 191, 194, 1);
      text-align: left;
      margin-bottom: 23px;
      .file-name {
        color: #000;
      }
    }
    .button {
      height: 45px;
      line-height: 45px;
      background:linear-gradient(90deg,rgba(254,170,0,1) 0%,rgba(255,209,5,1) 100%);
      border-radius:100px;
      font-size: 17px;
      font-family: PingFang SC;
      font-weight: 300;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>